var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"shop-text",attrs:{"href":_vm.shopLink}},[_c('div',{staticClass:"img"},[(_vm.counter > 0)?_c('span',{staticClass:"carrello-nr",domProps:{"textContent":_vm._s(_vm.counter)}}):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":"/img/frontend/sl-icon-03.svg"}})]),_vm._v(" "),_c('span',[_vm._v("Shop")])])
}
var staticRenderFns = []

export { render, staticRenderFns }